import React from 'react';
import { mergeClasses } from '@fluentui/react-components';

import CircularProgress from 'src/components/atoms/circular-progress/CircularProgress';
import { useActivityProgressBoxStyles } from './ActivityProgressBox.styles';

interface ActivityProgressBoxProps {
  className?: string
  circleClassName?: string
  displayedValue: string
  label: string
  progress: number
  progressColor?: string
  testId?: string
}

const ActivityProgressBox: React.FC<ActivityProgressBoxProps> = (props) => {
  const { className, circleClassName, displayedValue, label, progress, progressColor, testId } = props;
  const styles = useActivityProgressBoxStyles();

  return (
    <div className={mergeClasses('activity-progress-box', styles.circleBox, className)} data-testid={testId}>
      <CircularProgress className={circleClassName} progress={progress} showProgressText={false} strokeWidthRatio={0.06} progressColor={progressColor}>
        {displayedValue}
      </CircularProgress>

      <div className={styles.circleBoxTitle}>{label}</div>
    </div>
  );
};

export default ActivityProgressBox;
